import { ExternalRedirect } from 'components/atoms/ExternalRedirect';
import LoginRequired from 'components/layouts/LoggedInLayout';
import { Signup } from 'components/pages/SignupPage';
import PortalRouter from 'components/routes/PortalRouter';
import { CurrentPersonProvider } from 'context/currentPerson';
import { FirestoreAuthProvider } from 'context/firestoreAuth';
import React, { useEffect, Suspense, lazy } from 'react';
import {
  Switch,
  Route,
  useLocation,
  BrowserRouter as Router
} from 'react-router-dom';
import './App.css';
import CustomerIOAnalytics from 'utils/cio';

const AuthRoutes = lazy(() => import('./components/routes/AuthRoutes'));

const PageTracker: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname !== '/labs') {
      window.analytics?.page?.(location.pathname);
      window.cioanalytics?.page?.(location.pathname);
    }
  }, [location.pathname]);
  return null;
};

const App: React.FC = () => {
  return (
    <div className="App">
      <Suspense fallback={<div />}>
        <Router
          getUserConfirmation={() => {
            /* Empty callback to block the default browser prompt */
          }}
        >
          <CustomerIOAnalytics />
          <PageTracker />

          <Switch>
            <Route exact path="/">
              <AuthRoutes />
            </Route>
            <Route path="/signup">
              <Signup />
            </Route>
            <Route
              path={[
                '/register',
                '/login',
                '/forgot-password',
                '/logout',
                '/email-verification'
              ]}
            >
              <AuthRoutes />
            </Route>
            <Route path="/quiz">
              <ExternalRedirect to="https://www.parsleyhealth.com/psi" />
            </Route>
            <LoginRequired>
              <FirestoreAuthProvider>
                <CurrentPersonProvider>
                  <PortalRouter />
                </CurrentPersonProvider>
              </FirestoreAuthProvider>
            </LoginRequired>
            <Route path="*">
              <h1>404 page goes here</h1>
            </Route>
          </Switch>
        </Router>
      </Suspense>
    </div>
  );
};

export default App;
